var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.8 317.13C536.8 436.79 439.66 533.93 320 533.93C200.34 533.93 103.2 436.79 103.2 317.13C103.2 197.47 200.34 100.33 320 100.33C439.66 100.33 536.8 197.47 536.8 317.13Z",
    id: "awOZOwZTu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39 285.16L478.61 285.16L478.61 349.1L161.39 349.1L161.39 285.16Z",
    id: "bT49BwMhM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.97 158.52L351.97 475.74L288.03 475.74L288.03 158.52L351.97 158.52Z",
    id: "a1yuVbpBhV"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awOZOwZTu",
    opacity: 1,
    fill: "#404040",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bT49BwMhM",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1yuVbpBhV",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPassive);
export default __webpack_public_path__ + "static/media/plus_passive.b767eabacd2b3315c9a078d84a5990c5.svg";
export { ForwardRef as ReactComponent };